import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, type HTMLAttributes } from 'vue';
import { TabsList, type TabsListProps } from 'reka-ui';
import { cn } from '@/lib/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'TabsList',
  props: {
    loop: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(__props: any) {

const props = __props;
const forwarded = computed(() => {
  const { class: _class, ...rest } = props;
  return rest;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TabsList), _mergeProps(forwarded.value, {
    class: 
      _unref(cn)(
        'inline-flex h-9 max-w-full items-center justify-center gap-1 overflow-x-auto rounded-md bg-muted p-1 text-muted-foreground',
        props.class
      )
    
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})